import { API_BASE_URL } from '../utils/network'

export class ApiError extends Error {
  constructor(
    public status: number,
    public body: unknown,
    message: string
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export async function apiFetch<T>(
  path: string,
  options?: RequestInit
): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(options?.headers ?? {}),
    },
    ...options,
  })

  if (!response.ok) {
    let body: unknown
    try {
      body = await response.json()
    } catch {
      body = await response.text()
    }
    let message = `HTTP ${response.status}`
    if (typeof body === 'object' && body !== null && 'detail' in body) {
      const detail = (body as Record<string, unknown>).detail
      if (typeof detail === 'string') {
        message = detail
      } else if (typeof detail === 'object' && detail !== null && 'message' in detail) {
        message = String((detail as Record<string, unknown>).message)
      } else {
        message = String(detail)
      }
    }
    throw new ApiError(response.status, body, message)
  }

  if (response.status === 204) {
    return undefined as unknown as T
  }

  return response.json()
}

export function apiGet<T>(path: string): Promise<T> {
  return apiFetch<T>(path, { method: 'GET' })
}

export function apiPost<T>(path: string, body?: unknown): Promise<T> {
  return apiFetch<T>(path, {
    method: 'POST',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
}

export function apiPatch<T>(path: string, body?: unknown): Promise<T> {
  return apiFetch<T>(path, {
    method: 'PATCH',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  })
}

export function apiDelete<T>(path: string): Promise<T> {
  return apiFetch<T>(path, { method: 'DELETE' })
}
